import { render, staticRenderFns } from "./AdminCreateAccountDialog.vue?vue&type=template&id=54bf0ef8&scoped=true"
import script from "./AdminCreateAccountDialog.vue?vue&type=script&lang=js"
export * from "./AdminCreateAccountDialog.vue?vue&type=script&lang=js"
import style0 from "./AdminCreateAccountDialog.vue?vue&type=style&index=0&id=54bf0ef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bf0ef8",
  null
  
)

export default component.exports